module.exports = __webpack_public_path__ + "static/the-complete-calvin-and-hobbes-56387e8e0a16dff82e41f13f15252c7a.jpg";